import { RDMDepositRecordSerializer } from "@js/invenio_rdm_records/src/deposit/api/DepositRecordSerializer";
import {
  AllowAdditionsVocabularyField,
  Field,
  SchemaField,
  VocabularyField,
} from "@js/invenio_rdm_records/src/deposit/serializers";

export class UPDepositRecordSerializer extends RDMDepositRecordSerializer {
  constructor(defaultLocale, customFieldVocabularies = []) {
    super(defaultLocale, customFieldVocabularies);
  }

  get depositRecordSchema() {
    let schema = super.depositRecordSchema;
    // Add UP custom fields that require special schema, i.e. nested vocabulary fields
    schema["custom_fields.journal:journal.alternative_titles"] = new SchemaField({
      fieldpath: "custom_fields.journal:journal.alternative_titles",
      schema: {
        title: new Field({
          fieldpath: "title",
        }),
        type: new VocabularyField({
          fieldpath: "type",
          deserializedDefault: "",
          serializedDefault: "",
        }),
        lang: new VocabularyField({
          fieldpath: "lang",
          deserializedDefault: "",
          serializedDefault: "",
        }),
      },
    });
    schema["custom_fields.imprint:imprint.alternative_titles"] = new SchemaField({
      fieldpath: "custom_fields.imprint:imprint.alternative_titles",
      schema: {
        title: new Field({
          fieldpath: "title",
        }),
        type: new VocabularyField({
          fieldpath: "type",
          deserializedDefault: "",
          serializedDefault: "",
        }),
        lang: new VocabularyField({
          fieldpath: "lang",
          deserializedDefault: "",
          serializedDefault: "",
        }),
      },
    });
    schema["custom_fields.legal:related_entities"] = new SchemaField({
      fieldpath: "custom_fields.legal:related_entities",
      schema: {
        name: new Field({
          fieldpath: "name",
        }),
        type: new VocabularyField({
          fieldpath: "type",
          deserializedDefault: "",
          serializedDefault: "",
        }),
      },
    });
    schema["custom_fields.ubiquity:thesis.university"] =
      new AllowAdditionsVocabularyField({
        fieldpath: "custom_fields.ubiquity:thesis.university",
        deserializedDefault: [],
        serializedDefault: [],
        labelField: "name",
      });
    schema["custom_fields.ubiquity:thesis.type"] = new VocabularyField({
      fieldpath: "custom_fields.ubiquity:thesis.type",
      deserializedDefault: "",
      serializedDefault: "",
    });
    schema["custom_fields.ubiquity:thesis.degree_name"] = new VocabularyField({
      fieldpath: "custom_fields.ubiquity:thesis.degree_name",
      deserializedDefault: "",
      serializedDefault: "",
    });
    return schema;
  }
}
